import ReactDOM from "react-dom";
import "firebase/firestore";

import "./static/fonts/index.css";

// Persist Layout across client-side navigations so footer (Klaviyo embed, etc.) is not unmounted.
// Page components must not wrap themselves in <Layout> — see src/shared/wrapApp.tsx.
import { wrapPageElement, wrapRootElement } from "./src/shared/wrapApp";

export { wrapPageElement, wrapRootElement };

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
}

export const replaceHydrateFunction = () => {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
};